/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Pattern_Delete_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to delete pattern" |
*
* @param {Compliance_Pattern_Delete_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_pattern_delete_error = /** @type {((inputs?: Compliance_Pattern_Delete_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Pattern_Delete_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Löschen des Musters")
	return /** @type {LocalizedString} */ ("Failed to delete pattern")
});